import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { articles } from '../data/mock';

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const RelatedArticles = ({ current }) => {
  const currentSlug = current.slug;
  const pickRelated = useCallback(() => shuffle(articles.filter((a) => a.slug !== currentSlug)).slice(0, 3), [currentSlug]);
  const related = useMemo(pickRelated, [pickRelated]);
  if (!related.length) return null;
  return (
    <section className="py-24 bg-[#fbf9f5]" data-testid="related-articles">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <div className="flex items-end justify-between flex-wrap gap-6">
            <div>
              <div className="section-label mb-4"><span className="divider-gold"></span>Pour aller plus loin</div>
              <h2 className="font-serif text-4xl md:text-5xl text-[#010c23] font-light leading-tight">Articles similaires</h2>
            </div>
            <Link to="/actualites" className="btn-outline-dark" data-testid="related-all-link">Tous les articles <ArrowRight size={16} /></Link>
          </div>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6 no-justify">
          {related.map((a, i) => (
            <Reveal key={a.slug} delay={i * 80}>
              <Link to={`/actualites/${a.slug}`} className="group block bg-white border border-black/5 hover:border-[#ff7300] transition-colors h-full" data-testid={`related-article-${a.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={a.image} alt={a.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-[#010c23]/50">
                    <span className="text-[#ff7300]">{a.category}</span> <span>•</span> <span>{a.readTime}</span>
                  </div>
                  <h3 className="font-serif text-xl text-[#010c23] mt-3 leading-snug group-hover:text-[#ff7300] transition-colors">{a.title}</h3>
                  <p className="text-sm text-[#010c23]/65 mt-3 leading-relaxed line-clamp-3">{a.excerpt}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-[#010c23] group-hover:text-[#ff7300] transition-colors">Lire l’article <ArrowRight size={14} /></div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedArticles;
